import { CascadiaCustomIcon } from "@certn/cascadia-tokens";

export const customIconComponents: Record<CascadiaCustomIcon, React.ReactNode> =
  {
    "user-profile-circle": (
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="person icon"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 10.629c2.23 0 4.038-1.842 4.038-4.115C16.038 4.242 14.23 2.4 12 2.4c-2.23 0-4.038 1.842-4.038 4.114 0 2.273 1.808 4.115 4.038 4.115ZM12 21.6c3.393 0 6.425-1.608 8.4-4.114-1.975-2.507-5.007-4.115-8.4-4.115-3.393 0-6.425 1.608-8.4 4.115C5.575 19.992 8.607 21.6 12 21.6Z"
        />
      </svg>
    ),
    "my-certn-app": (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
      >
        <path
          d="M7.5457 4.21277H18.0117C18.2984 4.21277 18.5361 4.45763 18.5361 4.75307V21.4597C18.5361 21.7551 18.2984 22 18.0117 22H7.5457C7.25893 22 7.02124 21.7551 7.02124 21.4597V4.73976C7.02124 4.44432 7.24343 4.21277 7.5457 4.21277Z"
          fill="#E54A69"
        />
        <path
          d="M8.07409 0.164127L18.0431 4.1194C18.3214 4.23294 18.4513 4.54186 18.3373 4.8191L12.1932 20.2204C12.0792 20.4976 11.7691 20.627 11.4907 20.5135L1.52176 16.5582C1.24345 16.4447 1.11357 16.1357 1.22754 15.8585L7.38758 0.473051C7.48566 0.195812 7.79578 0.0505912 8.07409 0.164127Z"
          fill="#1BB794"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.3288 4.29616C18.4587 4.44138 18.509 4.65525 18.4428 4.86648L12.2986 20.2678C12.1846 20.545 11.8745 20.6744 11.5962 20.5608L7.02124 18.7548V4.81895C7.02124 4.52587 7.2651 4.28296 7.55932 4.28296H18.297C18.3129 4.29616 18.3288 4.29616 18.3288 4.29616Z"
          fill="#F8B64A"
        />
      </svg>
    ),
    bullet: (
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M15.6 12a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0Z" />
      </svg>
    ),
    select: (
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M11.223 17.674 8.34 14.848c-.351-.344-.43-.738-.235-1.182.194-.444.54-.666 1.04-.666h5.713c.499 0 .845.222 1.039.666.194.444.116.838-.235 1.182l-2.884 2.826A1.064 1.064 0 0 1 12 18a1.064 1.064 0 0 1-.777-.326ZM12.777 6.326l2.884 2.826c.351.344.43.738.235 1.182-.194.444-.54.666-1.04.666H9.144c-.499 0-.845-.222-1.039-.666-.195-.444-.116-.838.235-1.182l2.884-2.826c.111-.109.232-.19.361-.244.13-.055.268-.082.416-.082a1.063 1.063 0 0 1 .777.326Z" />
      </svg>
    ),
    google: (
      <svg
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.6626 17.2355C17.6266 15.4028 18.4993 12.3483 17.9756 9.42432H10.1645V12.6541H14.6153C14.4408 13.7013 13.8299 14.5741 12.9572 15.141L15.6626 17.2355Z"
          fill="#4285F4"
        />
        <path
          d="M2.74629 14.6615C3.32035 15.7922 4.14362 16.7779 5.15402 17.5442C6.16442 18.3105 7.33561 18.8375 8.57927 19.0853C9.82293 19.3332 11.1067 19.2955 12.3336 18.9751C13.5606 18.6547 14.6988 18.0599 15.6625 17.2356L12.9571 15.1411C10.6441 16.6687 6.80409 16.1011 5.49501 12.5229L2.74629 14.6615Z"
          fill="#34A853"
        />
        <path
          d="M5.49555 12.5228C5.14646 11.4316 5.14646 10.4283 5.49555 9.33703L2.74614 7.19922C1.74216 9.20647 1.43706 12.0432 2.74614 14.6613L5.49555 12.5228Z"
          fill="#FBBC02"
        />
        <path
          d="M5.49571 9.3377C6.455 6.32646 10.5575 4.58102 13.3062 7.1552L15.7065 4.79955C12.3029 1.52651 5.67025 1.65776 2.74629 7.19849L5.49571 9.337V9.3377Z"
          fill="#EA4335"
        />
      </svg>
    ),
    apple: (
      <svg
        width="21"
        height="21"
        viewBox="0 0 21 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.2653 3.53125C11.6019 3.08787 12.0371 2.72074 12.5398 2.45605C13.0425 2.19136 13.6003 2.03564 14.1735 2C14.2234 2.49694 14.1679 2.99837 14.0101 3.47442C13.8523 3.95046 13.5955 4.39136 13.2551 4.77083C12.9442 5.18342 12.5281 5.51374 12.0461 5.73062C11.564 5.94751 11.0319 6.0438 10.5 6.01042C10.4448 5.56934 10.4842 5.12218 10.6157 4.69603C10.7473 4.26988 10.9683 3.87361 11.2653 3.53125ZM7.43878 6.22917C5.29592 6.22917 3 8.05208 3 11.5521C3 15.125 5.67857 19.5 7.82143 19.5C8.58673 19.5 9.73469 18.7708 10.8827 18.7708C12.0306 18.7708 12.8724 19.4271 13.9439 19.4271C16.3163 19.4271 18 14.7604 18 14.7604C17.2687 14.4597 16.6465 13.9606 16.211 13.3252C15.7755 12.6898 15.5459 11.9464 15.551 11.1875C15.5515 10.5223 15.7356 9.86899 16.0848 9.29304C16.4341 8.7171 16.9362 8.23883 17.5408 7.90625C17.1485 7.34572 16.6118 6.89049 15.982 6.58409C15.3522 6.27769 14.6505 6.13038 13.9439 6.15625C12.4133 6.15625 11.2653 6.95833 10.6531 6.95833C9.96429 6.95833 8.81633 6.22917 7.43878 6.22917Z"
          fill="black"
        />
      </svg>
    ),
    linkedin: (
      <svg
        width="21"
        height="21"
        viewBox="0 0 21 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.7917 2.625H3.625C3.29348 2.625 2.97554 2.7567 2.74112 2.99112C2.5067 3.22554 2.375 3.54348 2.375 3.875V18.0417C2.375 18.3732 2.5067 18.6911 2.74112 18.9256C2.97554 19.16 3.29348 19.2917 3.625 19.2917H17.7917C18.1232 19.2917 18.4411 19.16 18.6756 18.9256C18.91 18.6911 19.0417 18.3732 19.0417 18.0417V3.875C19.0417 3.54348 18.91 3.22554 18.6756 2.99112C18.4411 2.7567 18.1232 2.625 17.7917 2.625ZM7.375 16.7917H4.875V9.29167H7.375V16.7917ZM6.125 7.83333C5.83849 7.82514 5.56074 7.7327 5.32646 7.56756C5.09218 7.40242 4.91176 7.17191 4.80775 6.90481C4.70373 6.63772 4.68073 6.3459 4.74162 6.06581C4.8025 5.78572 4.94458 5.52978 5.15009 5.32998C5.35561 5.13017 5.61544 4.99536 5.89714 4.94239C6.17883 4.88941 6.46989 4.92062 6.73395 5.03212C6.998 5.14362 7.22335 5.33046 7.38183 5.56929C7.5403 5.80813 7.62488 6.08837 7.625 6.375C7.61842 6.76696 7.45695 7.14038 7.17588 7.41364C6.8948 7.6869 6.51699 7.83779 6.125 7.83333ZM16.5417 16.7917H14.0417V12.8417C14.0417 11.6583 13.5417 11.2333 12.8917 11.2333C12.7011 11.246 12.5149 11.2962 12.3438 11.3811C12.1727 11.4659 12.02 11.5838 11.8946 11.7278C11.7691 11.8718 11.6734 12.0392 11.6128 12.2204C11.5523 12.4015 11.5281 12.5928 11.5417 12.7833C11.5375 12.8221 11.5375 12.8612 11.5417 12.9V16.7917H9.04167V9.29167H11.4583V10.375C11.7021 10.0042 12.037 9.70214 12.431 9.49786C12.825 9.29358 13.2648 9.19389 13.7083 9.20833C15 9.20833 16.5083 9.925 16.5083 12.2583L16.5417 16.7917Z"
          fill="#0A66C2"
        />
        <path d="M4.875 16.7917H7.375V9.29167H4.875V16.7917Z" fill="white" />
        <path
          d="M5.32646 7.56756C5.56074 7.7327 5.83849 7.82514 6.125 7.83333C6.51699 7.83779 6.8948 7.6869 7.17588 7.41364C7.45695 7.14038 7.61842 6.76696 7.625 6.375C7.62488 6.08837 7.5403 5.80813 7.38183 5.56929C7.22335 5.33046 6.998 5.14362 6.73395 5.03212C6.46989 4.92062 6.17883 4.88941 5.89714 4.94239C5.61544 4.99536 5.35561 5.13017 5.15009 5.32998C4.94458 5.52978 4.8025 5.78572 4.74162 6.06581C4.68073 6.3459 4.70373 6.63772 4.80775 6.90481C4.91176 7.17191 5.09218 7.40242 5.32646 7.56756Z"
          fill="white"
        />
        <path
          d="M14.0417 16.7917H16.5417L16.5083 12.2583C16.5083 9.925 15 9.20833 13.7083 9.20833C13.2648 9.19389 12.825 9.29358 12.431 9.49786C12.037 9.70214 11.7021 10.0042 11.4583 10.375V9.29167H9.04167V16.7917H11.5417V12.9C11.5375 12.8612 11.5375 12.8221 11.5417 12.7833C11.5281 12.5928 11.5523 12.4015 11.6128 12.2204C11.6734 12.0392 11.7691 11.8718 11.8946 11.7278C12.02 11.5838 12.1727 11.4659 12.3438 11.3811C12.5149 11.2962 12.7011 11.246 12.8917 11.2333C13.5417 11.2333 14.0417 11.6583 14.0417 12.8417V16.7917Z"
          fill="white"
        />
      </svg>
    ),
    sparkles: (
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.83112 1.35007C8.02574 0.784353 8.82582 0.784353 9.02044 1.35007L10.5796 5.88192C10.6426 6.06508 10.7865 6.20898 10.9696 6.272L15.5015 7.83112C16.0672 8.02574 16.0672 8.82582 15.5015 9.02044L10.9696 10.5796C10.7865 10.6426 10.6426 10.7865 10.5796 10.9696L9.02044 15.5015C8.82582 16.0672 8.02574 16.0672 7.83112 15.5015L6.272 10.9696C6.20898 10.7865 6.06508 10.6426 5.88192 10.5796L1.35007 9.02044C0.784353 8.82582 0.784353 8.02574 1.35007 7.83112L5.88192 6.272C6.06508 6.20898 6.20898 6.06508 6.272 5.88192L7.83112 1.35007Z"
          fill="#33777E"
        />
        <path
          d="M19.5293 13.2086C19.6591 12.8315 20.1925 12.8315 20.3222 13.2086L21.3616 16.2299C21.4036 16.352 21.4996 16.4479 21.6217 16.4899L24.6429 17.5293C25.0201 17.6591 25.0201 18.1925 24.6429 18.3222L21.6217 19.3616C21.4996 19.4036 21.4036 19.4996 21.3616 19.6217L20.3222 22.6429C20.1925 23.0201 19.6591 23.0201 19.5293 22.6429L18.4899 19.6217C18.4479 19.4996 18.352 19.4036 18.2299 19.3616L15.2086 18.3222C14.8315 18.1925 14.8315 17.6591 15.2086 17.5293L18.2299 16.4899C18.352 16.4479 18.4479 16.352 18.4899 16.2299L19.5293 13.2086Z"
          fill="#33777E"
        />
      </svg>
    ),
    sparkles_v2: (
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M7.83112 1.35007C8.02574 0.784353 8.82582 0.784353 9.02044 1.35007L10.5796 5.88192C10.6426 6.06508 10.7865 6.20898 10.9696 6.272L15.5015 7.83112C16.0672 8.02574 16.0672 8.82582 15.5015 9.02044L10.9696 10.5796C10.7865 10.6426 10.6426 10.7865 10.5796 10.9696L9.02044 15.5015C8.82582 16.0672 8.02574 16.0672 7.83112 15.5015L6.272 10.9696C6.20898 10.7865 6.06508 10.6426 5.88192 10.5796L1.35007 9.02044C0.784353 8.82582 0.784353 8.02574 1.35007 7.83112L5.88192 6.272C6.06508 6.20898 6.20898 6.06508 6.272 5.88192L7.83112 1.35007Z" />
        <path d="M19.5293 13.2086C19.6591 12.8315 20.1925 12.8315 20.3222 13.2086L21.3616 16.2299C21.4036 16.352 21.4996 16.4479 21.6217 16.4899L24.6429 17.5293C25.0201 17.6591 25.0201 18.1925 24.6429 18.3222L21.6217 19.3616C21.4996 19.4036 21.4036 19.4996 21.3616 19.6217L20.3222 22.6429C20.1925 23.0201 19.6591 23.0201 19.5293 22.6429L18.4899 19.6217C18.4479 19.4996 18.352 19.4036 18.2299 19.3616L15.2086 18.3222C14.8315 18.1925 14.8315 17.6591 15.2086 17.5293L18.2299 16.4899C18.352 16.4479 18.4479 16.352 18.4899 16.2299L19.5293 13.2086Z" />
      </svg>
    ),
    ai_spark: (
      <svg
        width="16"
        height="17"
        viewBox="0 0 16 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.5683 0.941745C12.4371 0.574105 11.9172 0.574106 11.7859 0.941746L11.1507 2.72139C11.1088 2.83873 11.0165 2.93107 10.8992 2.97295L9.11952 3.60816C8.75188 3.73939 8.75188 4.25931 9.11952 4.39053L10.8992 5.02575C11.0165 5.06763 11.1088 5.15997 11.1507 5.27731L11.7859 7.05695C11.9172 7.42459 12.4371 7.42459 12.5683 7.05695L13.2035 5.27731C13.2454 5.15997 13.3377 5.06763 13.4551 5.02575L15.2347 4.39053C15.6024 4.25931 15.6024 3.73939 15.2347 3.60816L13.4551 2.97295C13.3377 2.93107 13.2454 2.83873 13.2035 2.72139L12.5683 0.941745ZM6.80416 5.15199C6.64619 4.70943 6.02031 4.70943 5.86235 5.15199L4.61544 8.64538C4.56503 8.78663 4.45387 8.89779 4.31262 8.94821L0.819224 10.1951C0.376664 10.3531 0.376666 10.979 0.819225 11.1369L4.31262 12.3838C4.45387 12.4342 4.56503 12.5454 4.61544 12.6866L5.86235 16.18C6.02032 16.6226 6.64619 16.6226 6.80416 16.18L8.05106 12.6866C8.10148 12.5454 8.21264 12.4342 8.35389 12.3838L11.8473 11.1369C12.2898 10.979 12.2898 10.3531 11.8473 10.1951L8.35388 8.9482C8.21264 8.89779 8.10148 8.78663 8.05106 8.64538L6.80416 5.15199Z"
          fill="url(#paint0_linear_11005_12300)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_11005_12300"
            x1="7.99888"
            y1="0.666016"
            x2="7.99888"
            y2="16.512"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#38EEC7" />
            <stop offset="1" stopColor="#208871" />
          </linearGradient>
        </defs>
      </svg>
    ),
    ai_gen_text: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.6666 5.83398C6.6666 5.37375 7.0397 5.00065 7.49994 5.00065H12.4999C12.9602 5.00065 13.3333 5.37375 13.3333 5.83398C13.3333 6.29422 12.9602 6.66732 12.4999 6.66732H10.8333V13.334H12.4999C12.9602 13.334 13.3333 13.7071 13.3333 14.1673C13.3333 14.6276 12.9602 15.0007 12.4999 15.0007H7.49994C7.0397 15.0007 6.6666 14.6276 6.6666 14.1673C6.6666 13.7071 7.0397 13.334 7.49994 13.334H9.1666V6.66732H7.49994C7.0397 6.66732 6.6666 6.29422 6.6666 5.83398Z"
          fill="url(#paint0_linear_10595_21153)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.68621 13.9574C2.34052 14.1152 1.93236 13.9629 1.77458 13.6172C0.752549 11.3779 0.706182 8.80458 1.63583 6.53687C1.77998 6.18527 2.18186 6.01709 2.53346 6.16123C2.88507 6.30537 3.05325 6.70725 2.90911 7.05886C2.12337 8.97551 2.16261 11.1531 3.02647 13.0458C3.18425 13.3915 3.03191 13.7996 2.68621 13.9574Z"
          fill="url(#paint1_linear_10595_21153)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.0684 13.9665C16.7226 13.809 16.5699 13.4009 16.7274 13.0551C17.5948 11.1507 17.6262 8.95613 16.821 7.02841C16.6745 6.67777 16.84 6.27478 17.1906 6.12831C17.5413 5.98185 17.9443 6.14736 18.0907 6.49801C19.0431 8.77785 19.0065 11.3714 17.9798 13.6255C17.8223 13.9713 17.4142 14.124 17.0684 13.9665Z"
          fill="url(#paint2_linear_10595_21153)"
        />
        <path
          d="M4.24337 1.10132C4.3298 0.744873 4.83675 0.744873 4.92318 1.10132L5.161 2.0821C5.19186 2.20936 5.29123 2.30873 5.41849 2.33959L6.39927 2.57741C6.75572 2.66384 6.75572 3.17079 6.39927 3.25722L5.41849 3.49505C5.40258 3.49891 5.38711 3.50383 5.37215 3.50975C5.26746 3.55119 5.18801 3.64118 5.161 3.75253L4.92318 4.73332C4.91778 4.75559 4.91073 4.77648 4.90225 4.79597C4.77502 5.08837 4.3244 5.06748 4.24337 4.73332L4.00554 3.75253C4.00361 3.74458 4.00142 3.73673 3.99896 3.72901C3.96215 3.61312 3.86736 3.52398 3.74806 3.49505L2.76727 3.25722C2.74499 3.25182 2.72411 3.24478 2.70462 3.2363C2.41222 3.10907 2.4331 2.65844 2.76727 2.57741L3.74806 2.33959C3.87532 2.30873 3.97468 2.20936 4.00554 2.0821L4.24337 1.10132Z"
          fill="url(#paint3_linear_10595_21153)"
        />
        <path
          d="M15.0767 15.268C15.1631 14.9115 15.6701 14.9115 15.7565 15.268L15.9943 16.2488C16.0252 16.376 16.1246 16.4754 16.2518 16.5063L17.2326 16.7441C17.5891 16.8305 17.5891 17.3375 17.2326 17.4239L16.2518 17.6617C16.2359 17.6656 16.2204 17.6705 16.2055 17.6764C16.1008 17.7179 16.0213 17.8078 15.9943 17.9192L15.7565 18.9C15.7511 18.9223 15.7441 18.9431 15.7356 18.9626C15.6084 19.255 15.1577 19.2342 15.0767 18.9L14.8389 17.9192C14.8369 17.9112 14.8347 17.9034 14.8323 17.8957C14.7955 17.7798 14.7007 17.6906 14.5814 17.6617L13.6006 17.4239C13.5783 17.4185 13.5574 17.4114 13.5379 17.403C13.2456 17.2757 13.2664 16.8251 13.6006 16.7441L14.5814 16.5063C14.7087 16.4754 14.808 16.376 14.8389 16.2488L15.0767 15.268Z"
          fill="url(#paint4_linear_10595_21153)"
        />
        <path
          d="M15.8333 2.50065C15.8333 2.96089 15.4602 3.33398 14.9999 3.33398C14.5397 3.33398 14.1666 2.96089 14.1666 2.50065C14.1666 2.04041 14.5397 1.66732 14.9999 1.66732C15.4602 1.66732 15.8333 2.04041 15.8333 2.50065Z"
          fill="url(#paint5_linear_10595_21153)"
        />
        <path
          d="M5.83327 17.5007C5.83327 17.9609 5.46018 18.334 4.99994 18.334C4.5397 18.334 4.1666 17.9609 4.1666 17.5007C4.1666 17.0404 4.5397 16.6673 4.99994 16.6673C5.46018 16.6673 5.83327 17.0404 5.83327 17.5007Z"
          fill="url(#paint6_linear_10595_21153)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_10595_21153"
            x1="5.5"
            y1="3.5"
            x2="32.5"
            y2="27.5"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#1BB793" />
            <stop offset="1" stopColor="#0C5141" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_10595_21153"
            x1="5.5"
            y1="3.5"
            x2="32.5"
            y2="27.5"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#1BB793" />
            <stop offset="1" stopColor="#0C5141" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_10595_21153"
            x1="5.5"
            y1="3.5"
            x2="32.5"
            y2="27.5"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#1BB793" />
            <stop offset="1" stopColor="#0C5141" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_10595_21153"
            x1="5.5"
            y1="3.5"
            x2="32.5"
            y2="27.5"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#1BB793" />
            <stop offset="1" stopColor="#0C5141" />
          </linearGradient>
          <linearGradient
            id="paint4_linear_10595_21153"
            x1="5.5"
            y1="3.5"
            x2="32.5"
            y2="27.5"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#1BB793" />
            <stop offset="1" stopColor="#0C5141" />
          </linearGradient>
          <linearGradient
            id="paint5_linear_10595_21153"
            x1="5.5"
            y1="3.5"
            x2="32.5"
            y2="27.5"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#1BB793" />
            <stop offset="1" stopColor="#0C5141" />
          </linearGradient>
          <linearGradient
            id="paint6_linear_10595_21153"
            x1="5.5"
            y1="3.5"
            x2="32.5"
            y2="27.5"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#1BB793" />
            <stop offset="1" stopColor="#0C5141" />
          </linearGradient>
        </defs>
      </svg>
    ),
  };
